import type { Dict } from "../en";

export const me: Dict["me"] = {
  // The page
  preferences: "Tùy chọn",
  saved: "Đã lưu.",
  signOut: "Đăng xuất",
  thisDevice: "thiết bị này",
  off: "Tắt",
  // How Vantage talks to you
  howVantageTalks: "Cách Vantage trò chuyện với bạn",
  language: "Ngôn ngữ",
  matchMyMessage: "Theo tin nhắn của tôi",
  interfaceLanguage: "Ngôn ngữ giao diện",
  interfaceLanguageHelp: "Chữ hiển thị trong ứng dụng; Vantage vẫn trả lời bằng ngôn ngữ ở trên.",
  reachBy: "Liên hệ với tôi qua",
  reachWeb: "Web",
  reachEmail: "Email",
  reachBoth: "Cả hai",
  reachByHelp: "Nơi bạn nhận tin nhắn được chuyển cho bạn và các lời nhắc của bạn.",
  // Notifications
  notifications: "Thông báo",
  notificationsSub: "chuông và số chưa đọc luôn được cập nhật",
  quietHours: "Giờ yên tĩnh",
  quietHoursHelp: "Thông báo đẩy và email sẽ chờ đến hết giờ, rồi mới gửi nếu bạn vẫn chưa đọc.",
  quietFrom: "Từ",
  quietTo: "Đến",
  quietSameTime: "Giờ bắt đầu và giờ kết thúc không được trùng nhau.",
  quietOvernight: "{start}–{end} (qua đêm)",
  digestLabel: "Gửi email các thông báo chưa đọc cho tôi sau",
  digestHelp: "Một email (bản tổng hợp) liệt kê những gì bạn chưa đọc.",
  digestHelpOff:
    "Một email liệt kê những gì bạn chưa đọc. Hiện email đang tắt: bản tổng hợp sẽ bắt đầu khi quản trị viên bật email.",
  digestMinutes_one: "{n} phút",
  digestMinutes_other: "{n} phút",
  digestHours_one: "{n} giờ",
  digestHours_other: "{n} giờ",
  timeZone: "Múi giờ",
  timeZoneHelp: "Giờ yên tĩnh và lời nhắc dùng múi giờ này.",
  companyTimeZone: "Múi giờ của công ty",
  zoneThisDevice: " · thiết bị này",
  // Push notifications
  pushTitle: "Thông báo đẩy",
  pushRow: "Nhận thông báo trên thiết bị này",
  pushIncomplete: "Trình duyệt này không trả về đủ thông tin đăng ký nhận thông báo.",
  pushOnToast: "Đã bật thông báo trên thiết bị này.",
  pushOnFailed: "Không bật được thông báo.",
  pushOffToast: "Đã tắt thông báo trên thiết bị này.",
  pushOffFailed: "Lúc này chưa tắt được thông báo.",
  pushChecking: "Đang kiểm tra…",
  pushOnHere:
    "Đang bật: lượt nhắc đến, trả lời, tin nhắn được chuyển cho bạn và báo cáo đã xong sẽ hiện ở đây, kể cả khi Vantage EX đang đóng.",
  pushOnElsewhere: "Đang bật trên một thiết bị khác của bạn. Bật cả ở đây nữa nhé?",
  pushOffHere:
    "Nhận thông báo khi có người nhắc đến bạn, trả lời bạn, hoặc khi báo cáo đã sẵn sàng.",
  // Your profile
  profileTitle: "Hồ sơ của bạn",
  profileSaved: "Đã lưu hồ sơ.",
  profileName: "Tên",
  profileNameHelp: "Tên mọi người và Vantage dùng để gọi bạn; @nhắc đến cũng dùng tên này.",
  profileFullName: "Họ và tên",
  profileAbout: "Giới thiệu",
  profileAboutHelp: "{n}/{max} · bạn là ai và đang làm gì; mọi người đều đọc được.",
  profileTitleField: "Chức danh",
  profileTitleHelp: "Quản trị viên đặt chức danh: chức danh cho biết ai làm việc gì.",
  profileSave: "Lưu hồ sơ",
  // Signed-in devices
  devicesTitle: "Thiết bị đang đăng nhập",
  devicesWhat: "thiết bị của bạn",
  devicesNone: "Không có thiết bị nào khác đang đăng nhập.",
  devicesThisDevice: "Thiết bị này",
  devicesLastActive: "Hoạt động lần cuối {when}",
  devicesSignedOutOne: "Đã đăng xuất thiết bị đó.",
  devicesSignedOutOthers: "Đã đăng xuất trên mọi thiết bị khác.",
  devicesSignOutOthers: "Đăng xuất các thiết bị khác",
  // Passkeys
  passkeys: "Khóa truy cập (passkey)",
  passkeysWhat: "khóa truy cập của bạn",
  passkeysHelp:
    "Đăng nhập bằng Face ID, Touch ID hoặc khóa màn hình của thiết bị thay cho liên kết qua email.",
  passkeysNone: "Chưa có khóa truy cập nào.",
  passkeyAdd: "Thêm khóa truy cập",
  passkeyAdded: "Đã thêm khóa truy cập.",
  passkeyAddFailed: "Không thêm được khóa truy cập trên thiết bị này.",
  passkeyExists: "Thiết bị này đã có khóa truy cập cho trang này rồi.",
  passkeyUnsupported: "Trình duyệt này không tạo được khóa truy cập.",
  passkeyInsecure:
    "Khóa truy cập chỉ dùng được trên địa chỉ bảo mật (https) của Vantage EX, không phải địa chỉ này.",
  passkeySignInAgain: "Đăng nhập lại",
  passkeyName: "Tên khóa truy cập",
  passkeyRename: "Đổi tên",
  passkeyRenameFailed: "Không đổi tên được.",
  passkeyRemove: "Xóa",
  passkeyRemoveTitle: "Xóa khóa truy cập này?",
  passkeyRemoveBody: "Xóa “{name}”? Bạn vẫn đăng nhập được bằng liên kết qua email.",
  passkeyRemoveConfirm: "Xóa khóa truy cập",
  passkeyRemoved: "Đã xóa khóa truy cập.",
  passkeyRemoveFailed: "Không xóa được.",
  passkeyAddedOn: "Đã thêm {date} · {used}",
  passkeyLastUsed: "Dùng lần cuối {date}",
  passkeyNeverUsed: "Chưa dùng lần nào",
  passkeySignIn: "Đăng nhập bằng khóa truy cập",
  passkeySignInFailed: "Khóa truy cập đó không dùng được. Hãy dùng liên kết qua email.",
};
